module.exports = __webpack_public_path__ + "img/ycd.7a751929.png";